import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M230.053 453.333H0V240H230.053C275.043 100.733 405.758 0 560 0 714.242 0 844.957 100.733 889.947 240H1920V453.333H889.947C844.957 592.601 714.242 693.333 560 693.333 405.758 693.333 275.043 592.601 230.053 453.333zM426.667 346.667C426.667 273.029 486.362 213.333 560 213.333 633.638 213.333 693.333 273.029 693.333 346.667 693.333 420.305 633.638 480 560 480 486.362 480 426.667 420.305 426.667 346.667zM0 853.333H976.72C1021.71 714.066 1152.42 613.333 1306.67 613.333 1460.91 613.333 1591.62 714.066 1636.61 853.333H1920V1066.67H1636.61C1591.62 1205.93 1460.91 1306.67 1306.67 1306.67 1152.42 1306.67 1021.71 1205.93 976.72 1066.67H0V853.333zM1306.67 826.667C1233.03 826.667 1173.33 886.362 1173.33 960 1173.33 1033.64 1233.03 1093.33 1306.67 1093.33 1380.3 1093.33 1440 1033.64 1440 960 1440 886.362 1380.3 826.667 1306.67 826.667zM889.947 1680C844.957 1819.27 714.242 1920 560 1920 405.758 1920 275.043 1819.27 230.053 1680H0V1466.67H230.053C275.043 1327.4 405.758 1226.67 560 1226.67 714.242 1226.67 844.957 1327.4 889.947 1466.67H1920V1680H889.947zM426.667 1573.33C426.667 1499.7 486.362 1440 560 1440 633.638 1440 693.333 1499.7 693.333 1573.33 693.333 1646.97 633.638 1706.67 560 1706.67 486.362 1706.67 426.667 1646.97 426.667 1573.33z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconConfigureSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconConfigureSolid, _Component);

  var _super = _createSuper(IconConfigureSolid);

  function IconConfigureSolid() {
    _classCallCheck(this, IconConfigureSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconConfigureSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconConfigure",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconConfigureSolid.displayName = "IconConfigureSolid";
  return IconConfigureSolid;
}(Component);

IconConfigureSolid.glyphName = 'configure';
IconConfigureSolid.variant = 'Solid';
IconConfigureSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconConfigureSolid;
export { IconConfigureSolid };